module.exports = __webpack_public_path__ + "img/gzh.e8f54baf.png";